import { Dialog, DialogContent, DialogContentWrapper, DialogOverlay, DialogPortal } from '@journ/ui/dialog'
import { tv } from '@/libs/tv'
import type { ComponentProps } from 'react'

type SheetProps = {
	isOpen: boolean
	toggle: () => void
} & ComponentProps<typeof DialogContent>

const contentStyles = tv({
	base: [
		'fixed inset-0 z-50',
		'h-dvh w-dvw p-0',
		'bg-transparent border-none',
		'data-[state=closed]:animate-fadeout-scale-down data-[state=open]:animate-fadein-scale-up',
	],
})

const Sheet = ({ isOpen, toggle, children, className }: SheetProps) => {
	return (
		<Dialog open={isOpen} onOpenChange={toggle}>
			<DialogPortal>
				<DialogOverlay className='z-10' />
				<DialogContentWrapper className={contentStyles({ class: className })}>{children}</DialogContentWrapper>
			</DialogPortal>
		</Dialog>
	)
}

export { Sheet }
